import { useGetDealDropdownValues } from "@vega-api/generated/deal-dropdowns/deal-dropdowns";
import { type OptionWithId } from "@vega-core/models/options";

export const useDealDropdownValues = () => {
  const { data, isLoading, error } = useGetDealDropdownValues({
    query: {
      select: (response) => response.data,
    },
  });

  const formatOptions = (
    values?: { value: string; label: string }[],
  ): OptionWithId[] =>
    values?.map((item) => ({
      value: item.value,
      label: item.label,
    })) || [];

  return {
    isLoading,
    error,
    assetClassOptions: formatOptions(data?.assetClasses),
    sectorOptions: formatOptions(data?.sectors),
    regionOptions: formatOptions(data?.regions),
    securityTypeOptions: formatOptions(data?.securityTypes),
    activeOrPastOptions: formatOptions(data?.activeOrPast),
    investedOrPassedOptions: formatOptions(data?.investedOrPassed),
    inclusionReasonsOptions: formatOptions(data?.inclusionReasons),
  };
};
